import React from "react";
import { ILeagueRank, ILeagueWeek } from "../../../../helpers/interfaces/league";
import { log } from "../../../../helpers/utils/log";

interface ILeagueLeaderboardState {
  loading: boolean;
  ranks: ILeagueRank[];
  originalRanks: ILeagueRank[];
  activeWeek: ILeagueWeek | null;
  activePage: number;
  lastUpdated: Date;
  nameFilter: string | null;
  logMessage?: { message: string, color: string, icon?: React.ReactNode };
}

export const leagueLeaderboardInitialState: ILeagueLeaderboardState = {
  loading: true,
  ranks: [],
  originalRanks: [],
  activeWeek: null,
  activePage: 0,
  lastUpdated: new Date(),
  nameFilter: null,
  logMessage: { message: "", color: "" }
}

export enum ELeagueLeaderboardActions {
  SetRankings = "SetRankings",
  SetPage = "SetPage",
  SetNameFilter = "SetNameFilter",
}

interface ILeagueLeaderboardAction {
  type: ELeagueLeaderboardActions;
  activeWeek?: ILeagueWeek | null;
  ranks?: ILeagueRank[];
  page?: number;
  filter?: string;
  logMessage?: { message: string, color: string, icon?: React.ReactElement };
}


const filterByName = (ranks: ILeagueRank[], filter: string): ILeagueRank[] => {
  const searchTerms = filter.trim().split(/\s+/);
  if (!searchTerms.length) {
    return ranks;
  }

  return ranks.filter(r => {
    // Check if all search terms are present in the nickname property
    return searchTerms.every(term => {
      try {
        const regex = new RegExp(term, 'i');
        return regex.test(r.nickname);
      } catch (e) {
        return true;
      }
    });
  });
};

export const leagueLeaderboardReducer = (state: ILeagueLeaderboardState, action: ILeagueLeaderboardAction): ILeagueLeaderboardState => {
  const reducer = (state: ILeagueLeaderboardState, action: ILeagueLeaderboardAction): ILeagueLeaderboardState => {
    let ranks: ILeagueRank[] = [];
    switch (action.type) {
      case ELeagueLeaderboardActions.SetNameFilter:
        const filter = (action.filter || "").toLowerCase();
        ranks = action.filter ? filterByName(state.originalRanks, filter) : state.originalRanks;

        return {
          ...state,
          nameFilter: filter || null,
          ranks,
          lastUpdated: new Date()
        }

      case ELeagueLeaderboardActions.SetRankings:
        ranks = action.ranks || [];

        if (state.nameFilter) {
          ranks = filterByName(ranks, state.nameFilter);
        }

        return {
          ...state,
          ranks: ranks,
          originalRanks: action.ranks || [],
          lastUpdated: new Date()
        }

      case ELeagueLeaderboardActions.SetPage:
        return {
          ...state,
          activePage: action.page || 0
        }

      default:
        return state;
    }
  }

  log("LeagueLeaderboardState", `Dispatching a new action: `, action);
  const newState = reducer(state, action);
  log("LeagueLeaderboardState", `New state: `, newState);

  return newState;
}